import { Component, OnInit } from "@angular/core";
import { User } from "../../shared/models/user.model";
import { ActivatedRoute, Router } from "@angular/router";
import { switchMap } from "rxjs/operators";
import { EMPTY } from "rxjs";
import { ProfileService } from "../../shared/services/profile.service";
import { ImageHandlerService } from "../../shared/services/image-handler.service";
import { MatDialog } from "@angular/material/dialog";
import { OtpResetDialogComponent } from "./otp-reset-dialog/otp-reset-dialog.component";
import { DatawrapperHelpDialogComponent } from "./datawrapper-help-dialog/datawrapper-help-dialog.component";
import { MaterialModule } from "src/app/app.materials";
import { FormsModule } from "@angular/forms";

import { HouseViewsSetterComponent } from "../../components/house-views-setter/house-views-setter.component";
import { HouseViewsReadonlyComponent } from "../../components/house-views-readonly/house-views-readonly.component";
import { HouseViewsService } from "../../shared/services/house-views.service";

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
  imports: [
    MaterialModule,
    FormsModule,
    HouseViewsSetterComponent,
    HouseViewsReadonlyComponent,
  ],
  standalone: true,
})
export class SettingsComponent implements OnInit {
  public id: number = null;
  public item: User = new User();
  public image: any = null;
  public qrCodeSrc = null;
  public userHouseViews: any[] = [];
  public firmHouseViews: any[] = [];
  public hasCompany = false;
  public canEditFirmHouseViews = false;

  otpTypes = ["app", "email"];

  constructor(
    private service: ProfileService,
    private router: Router,
    private route: ActivatedRoute,
    private imageHandler: ImageHandlerService,
    private dialog: MatDialog,
    private houseViewsService: HouseViewsService,
  ) {}

  ngOnInit() {
    this.fetchItem();
    this.fetchHouseViews();
  }

  fetchHouseViews() {
    this.houseViewsService.getUserViews().subscribe((views: any) => {
      this.userHouseViews = views;
    });
  }

  fetchItem() {
    return this.service
      .getItem()
      .pipe(
        switchMap((result) => {
          this.item = result;
          this.hasCompany = !!(this.item.company_id || this.item.company?.id);
          this.canEditFirmHouseViews =
            this.item.isSuperAdmin() || !!this.item.can_manage_firm_house_views;
          return this.hasCompany
            ? this.houseViewsService.getFirmViews()
            : EMPTY;
        }),
      )
      .subscribe((views: any) => {
        if (views) {
          this.firmHouseViews = views;
        }
      });
  }

  onSaveClick() {
    if (!this.item.isValid()) {
      this.service.notificationService.invalidForm();
      return;
    }
    const photoCache = this.item.photo ? this.item.photo : null;

    this.service.save(this.item).subscribe((response) => {
      if (response.error) {
        return this.service.notificationService.open(response.error);
      }
      this.service.notificationService.open("Saved!");
      this.item.photo = photoCache;
    });
  }

  open2faResetDialog(qrCode) {
    const dialogRef = this.dialog.open(OtpResetDialogComponent, {
      data: { qrCode },
      maxWidth: "400px",
      autoFocus: false,
      width: "100%",
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((resp: any) => {
      this.onSaveClick();
    });
  }

  onDatawrapperHelpClick() {
    this.dialog.open(DatawrapperHelpDialogComponent, {
      maxWidth: "800px",
      disableClose: true,
    });
  }

  onReset2FAClicked() {
    this.service.getTwoFAReset().subscribe((response: any) => {
      if (response.success) {
        this.open2faResetDialog(response.success.qrCodeSrc);
      } else {
        this.service.notificationService.open(
          response.error ? response.error : "Something went wrong.",
        );
      }
    });
  }

  handleInputChange(e) {
    this.imageHandler.getBase64Image(e).then((res: string) => {
      if (res) {
        this.item.photo = res;
      }
    });
  }
}
